Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-compare-box', function (envelope) {

        var $context = envelope.message.data.context,
            $boxes = $('.x-product-compare-box', $context);

        if ($boxes.length < 1)
            return;

        $boxes.on('click', '.js-remove', function (e) {
            e.preventDefault();

            var $this = $(this);
            var $item = $this.closest('.x-product-compare-box');
            var id = $item.data('productid');

            Vendd.MessageBus.publishAsync($item, new Vendd.ProductCompare.Messages.Remove(id));
            if ($('.x-productcompare-widget').data('template') === 1) {
                //Open the widget only for template 1 of Compare Widget
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-request-info', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            $.fancybox.open({
                src: '#request-info-form',
                type: 'inline',
                touch: false,
                autoFocus: false
            });
        });

    });

});